<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-account" icon-small title="لیست بازاریاب ها" color="accent">
			<template v-slot:topActions>
				<v-btn color="primary" dark @click="add">
					<v-icon dark>
						mdi-plus-circle-outline
					</v-icon>
					افزودن بازاریاب
				</v-btn>
			</template>
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :headers="headers" :items="users" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>{{ row.item.fullName }}</td>
										<td>{{ row.item.userName }}</td>
										<td>{{ row.item.affiliateCode }}</td>
										<td class="text-center">
											{{ row.item.totalCommission.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.totalPaids.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.viewCount }}
										</td>
										<td class="text-center">
											{{ `${row.item.lastLoginDate_Persian.date} ${row.item.lastLoginDate_Persian.time}` }}
										</td>
										<td class="text-center">
											<v-btn class="mx-1" fab dark small color="success" @click="commissions(row.item)">
												<v-icon dark>
													mdi-currency-usd
												</v-icon>
											</v-btn>
											<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
												<v-icon dark>
													mdi-square-edit-outline
												</v-icon>
											</v-btn>
											<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
												<v-icon dark>
													mdi-trash-can-outline
												</v-icon>
											</v-btn>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-dialog v-model="dialogUser" scrollable persistent max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات بازاریاب</span>
						<v-spacer />
						<v-btn @click="dialogUser = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-marketer ref="modifyUser" v-if="dialogUser" :data="selectedUser" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogMarketerAffiliateCommissions" scrollable max-width="1100px">
				<v-card>
					<v-card-title>
						<div><span class="headline">لیست پورسانت های بازاریاب {{ `(${this.selectedUser.fullName})` }}</span></div>
						<v-spacer />
						<v-btn @click="dialogMarketerAffiliateCommissions = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text style="height: 600px;">
						<v-container>
							<marketer-affiliate-commissions ref="marketerAffiliateCommissions" :data="selectedUser" v-if="dialogMarketerAffiliateCommissions" />
						</v-container>
					</v-card-text>

				</v-card>
			</v-dialog>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import ModifyMarketer from './ModifyMarketer.vue'
	import MarketerAffiliateCommissions from './MarketerAffiliateCommissions.vue'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'modify-marketer': ModifyMarketer,
			'marketer-affiliate-commissions': MarketerAffiliateCommissions,
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedUser: {},
				dialogUser: false,
				dialogMarketerAffiliateCommissions: false,
				search: '',
				headers: [
					{
						text: 'نام بازاریاب',
						align: 'start',
						sortable: true,
						value: 'fullName',
					}, {
						text: 'نام کاربری',
						align: 'start',
						sortable: true,
						value: 'userName',
					}, {
						text: 'کد معرفی',
						align: 'start',
						sortable: true,
						value: 'affiliateCode',
					}, {
						text: 'مجموع پورسانت ها',
						align: 'start',
						sortable: true,
						value: 'totalCommission',
					}, {
						text: 'مجموع تسویه',
						align: 'start',
						sortable: true,
						value: 'totalPaids',
					}, {
						text: 'دفعات مراجعه',
						align: 'center',
						sortable: true,
						value: 'viewCount',
					}, {
						text: 'آخرین فعالیت',
						align: 'center',
						sortable: true,
						value: 'lastLoginDate_Persian',
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 220,
					},
				],
				users: [],
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				api.get('superadmin/marketer/list', null)
					.then(
						response => {
							this.users = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			add() {
				this.dialogUser = true
				this.selectedUser = { id: 0 }
			},
			edit(item) {
				this.dialogUser = true
				this.selectedUser = item
			},
			callbck(result) {
				this.dialogUser = false
				if (result) { this.loadData() }
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('superadmin/marketer/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			commissions(item) {
				this.selectedUser = item
				this.dialogMarketerAffiliateCommissions = true
			}
		},
	}
</script>
<style>
</style>
